// Source-of-truth for the legal terms a new user accepts at signup.
//
// CURRENT_TERMS_VERSION is stamped onto users.terms_version by the signup API
// (src/app/api/auth/signup/route.ts) so we have a per-user audit trail of who
// agreed to which version and when. Bump it (to a new ISO date) whenever the
// hosted Terms of Use materially change, so future acceptances record the new
// version. Keep the format as a plain YYYY-MM-DD date string.
//
// History: 2026-07-22 (first recorded version) → 2026-11-04 (Mucka-Website
// PR #154: §1 covers the mucka.ai website; new §2.1–2.4 on protecting Mucka,
// confidentiality, feedback and remedies; §10 adds suspension for breach and
// survival). There is no re-acceptance flow: existing users keep the version
// they signed up on, and §11 promises them notice of a material change.
export const CURRENT_TERMS_VERSION = "2026-11-04";

export const TERMS_URL = "https://mucka.ai/terms-of-use/";
export const PRIVACY_URL = "https://mucka.ai/privacy/";
